import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const ADecisionWasMade = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack>
      <Typography variant='body5'>
        {dictionary.steps.step3.listTitle}
      </Typography>
      <ul style={{ marginTop: 0, listStylePosition: 'inside', padding: 0 }}>
        <Typography component={'li'} variant='body6'>
          - {dictionary.steps.step3.li1}
        </Typography>
        <Typography component={'li'} variant='body6'>
          - {dictionary.steps.step3.li2}
        </Typography>
      </ul>
      <Typography variant='body6' sx={{ mb: '20px' }}>
        {dictionary.steps.step3.info1}
      </Typography>
      <Typography variant='body6'>
        <strong>{dictionary.steps.step3.info2[0]}</strong>
        {dictionary.steps.step3.info2[1]}
      </Typography>
      <Typography variant='body6'>{dictionary.steps.step3.info3}</Typography>
    </Stack>
  );
};
